import { render, staticRenderFns } from "./ConfigurationAdmins.vue?vue&type=template&id=fa405c32&scoped=true"
import script from "./ConfigurationAdmins.vue?vue&type=script&lang=js"
export * from "./ConfigurationAdmins.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationAdmins.vue?vue&type=style&index=0&id=fa405c32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa405c32",
  null
  
)

export default component.exports